import './Switch.css'


type Props = {
  label : string,
  onChange : (e : any) => void,
  checked: boolean
}

const uuid = generateUuid()

export default function Switch(props : Props) {
  return (
    <div className="toggle_button">
      <input id={`toggle_${uuid}`} className="toggle_input" type='checkbox' onClick={props.onChange} checked={props.checked} />
      <label htmlFor={`toggle_${uuid}`} className="toggle_label"/>
      <label htmlFor={`toggle_${uuid}`} className="toggle_label_text">{props.label}</label>
    </div>
  )
}

function generateUuid() {
  let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
  for (let i = 0, len = chars.length; i < len; i++) {
    switch (chars[i]) {
      case "x":
        chars[i] = Math.floor(Math.random() * 16).toString(16);
        break;
      case "y":
        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
        break;
    }
  }
  return chars.join("");
}